import axios from 'axios';
import qs from 'query-string';
import { buildUrl } from '../utils/helpers';
/*global SERVER, PORT */

type Config = { get: (key: string) => string };
type ConfigFuc = (config: Config) => string;
const resolveHost = ({
  backend,
  staging,
  production,
}: {
  backend: string | ConfigFuc;
  staging: string;
  production: string;
}): string => {
  if (typeof SERVER === 'undefined' || SERVER) {
    if (typeof backend === 'string') {
      return backend;
    } else {
      // Dynamic require here to prevent config being included in main bundle
      return backend(require('config'));
    }
  }

  const isE2eTest = window?.location?.host?.includes('e2e');
  const isInternalHost = window?.location?.host?.includes('k8s.hipages') && !isE2eTest;
  return isInternalHost ? staging : production;
};

export const supoUrl = buildUrl(
  resolveHost({
    backend: config => config.get('app.supoServiceUrl'),
    staging: 'https://master-supo.k8s.hipages.com.au',
    production: 'https://api.hipages.com.au',
  }),
  '/api/supo'
);

export const hipNewUrl = buildUrl(
  resolveHost({
    backend: `http://localhost:${typeof PORT === 'undefined' ? '10010' : PORT}/`,
    staging: 'https://master-hip-new-www.k8s.hipages.com.au',
    production: 'https://hipages.com.au',
  }),
  '/'
);

export const lectioUrl = buildUrl(
  resolveHost({
    backend: config => config.get('app.lectioServiceUrl'),
    staging: 'https://master-lectio.k8s.hipages.com.au',
    production: 'https://api.hipages.com.au',
  }),
  '/article/api'
);

export const tradieApiUrl = buildUrl(
  resolveHost({
    backend: config => config.get('app.tradieServiceUrl'),
    staging: 'https://master-hip-new-api.k8s.hipages.com.au',
    production: 'https://api.hipages.com.au',
  }),
  '/hip-new/tradie/v1'
);

export const doeApiUrl = buildUrl(
  resolveHost({
    backend: config => config.get('app.doeServiceUrl'),
    staging: 'https://master-doe-assessment-api.k8s.hipages.com.au',
    production: 'https://doe-assessment-api.k8s.hipages.com.au',
  }),
  '/'
);

export const locationApi = axios.create({
  baseURL: 'https://cerebro.k8s.hipages.com.au/suggest/location',
});

export const supo = axios.create({ baseURL: supoUrl });
export const hipNew = axios.create({ baseURL: hipNewUrl });
export const lectio = axios.create({ baseURL: lectioUrl });
export const tradieApi = axios.create({ baseURL: tradieApiUrl });
export const doeApi = axios.create({ baseURL: doeApiUrl });

export type RegisterFields = {
  firstName: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  email: string;
};

export function register(data: Partial<RegisterFields>) {
  const dataToPost = {
    email: data.email,
    firstname: data.firstName,
    lastname: data.lastName,
    password: data.password,
    password_confirm: data.confirmPassword,
  };
  return hipNew.post('/register-ajax', qs.stringify(dataToPost));
}
